function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Chat-Widget",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Group-5",
  transform: "translate(1.000000, 2.000000)",
  fillRule: "nonzero",
  stroke: "#FFFFFF"
}, React.createElement("g", {
  id: "noun_Mute_1954046-Copy",
  strokeWidth: 2
}, React.createElement("polygon", {
  id: "Path",
  points: "0 4.27398783 0 11.0274675 2.26108745 11.0274675 8.65948384 15.3014553 8.65948384 0 2.26108745 4.27398783"
}), React.createElement("path", {
  d: "M3.5,11.7125775 L3.5,3.53256489 L3.5,11.7125775 Z",
  id: "Path"
})), React.createElement("g", {
  id: "noun_Sound_1818835",
  transform: "translate(11.000000, 0.000000)",
  fill: "#FFFFFF",
  strokeWidth: 0.5
}, React.createElement("g", {
  id: "Group",
  transform: "translate(0.046367, 0.000000)"
}, React.createElement("path", {
  d: "M5.8053493,0.231430472 C5.52823834,-0.0456804909 5.07890885,-0.0456804909 4.80170326,0.231430472 C4.5245923,0.508494123 4.5245923,0.957870925 4.80170326,1.23507651 C6.60687514,3.04024839 7.60110594,5.44454203 7.60110594,8.00496784 C7.60110594,10.5653937 6.60687514,12.9696873 4.80170326,14.7748592 C4.5245923,15.0519701 4.5245923,15.5013469 4.80170326,15.7785052 C4.94032971,15.917179 5.12191617,15.9864922 5.30354994,15.9864922 C5.48513639,15.9864922 5.66681748,15.917179 5.80525468,15.7785052 C7.8785954,13.7052591 9.02039477,10.9445583 9.02039477,8.00496784 C9.02039477,5.06537739 7.87869003,2.30472389 5.8053493,0.231430472 Z",
  id: "Path"
}), React.createElement("path", {
  d: "M3.53064538,2.50632365 C3.25358173,2.22911806 2.80420492,2.22921269 2.52699933,2.50622902 C2.24979375,2.7833873 2.24979375,3.23266948 2.52699933,3.50996969 C5.00547941,5.98854439 5.00547941,10.0214859 2.52699933,12.5000606 C2.24979375,12.7771716 2.24979375,13.2265484 2.52699933,13.5037067 C2.66553116,13.6422385 2.84721224,13.711599 3.02875139,13.711599 C3.21043247,13.711599 3.39201893,13.6422385 3.53055075,13.5037067 C6.56254306,10.4717143 6.56254306,5.53831596 3.53064538,2.50632365 Z",
  id: "Path"
}), React.createElement("path", {
  d: "M1.25584682,4.78102757 C0.978783174,4.50391661 0.529406372,4.50391661 0.252200784,4.78102757 C-0.0249101796,5.05813854 -0.0249574924,5.50751534 0.252200784,5.78467362 C1.47632439,7.00898647 1.47632439,9.00094921 0.252200784,10.2251674 C-0.0249574924,10.5022784 -0.0249574924,10.9516552 0.252200784,11.2288608 C0.390732609,11.3673926 0.572461004,11.4367058 0.753952835,11.4367058 C0.935633917,11.4367058 1.11722037,11.3673926 1.2557522,11.2288608 C3.03338804,9.45122496 3.03338804,6.55880535 1.25584682,4.78102757 Z",
  id: "Path"
})))));

var SvgSoundOn = function SvgSoundOn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "22px",
    height: "20px",
    viewBox: "0 0 22 20",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSoundOn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SoundOn.e6b7c76e.svg";
export { ForwardRef as ReactComponent };